import React, { useState, useEffect } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaChevronUp,
} from "react-icons/fa";
import { useLanguage } from "../pages/LanguageContext";

const translations = {
  en: {
    pageTitle:
      "For any questions or inquiries, please fill out the form below.",
    name: "Name",
    email: "Email Address",
    mobile: "Mobile",
    subject: "Subject",
    message: "Message",
    sending: "Sending...",
    sendMessage: "Send Message",
    ammanHQ: "Amman HQ",
    address: "Address",
    phone: "Phone",
    whatsapp: "WhatsApp",
    ammanAddress: "Yazid Al Asadi St, 7th Circle, Amman, Jordan",
    ammanPhone: "+962 79 292 3333",
    dubaiBranch: "Dubai Branch",
    dubaiAddress: "Umm Suqeim St, Al Barsha, Dubai, United Arab Emirates",
    dubaiPhone: "+971 50 700 5035 ",
    contactEmails: "Contact Emails",
    supportEmail: "Support Email",
    hrEmail: "HR Email",
    followUs: "Follow us:",
    alertSuccess: "Thank you! Your message has been sent.",
    alertFail: "Failed to send message. Please try again.",
    alertError: "Error sending message. Please try again later.",
    ammanInstagram: "Instagram (Amman)",
    dubaiInstagram: "Instagram (Dubai)",
  },
  ar: {
    pageTitle: "لأي استفسارات أو أسئلة، يرجى تعبئة النموذج أدناه",
    name: "الاسم",
    email: "البريد الإلكتروني",
    mobile: "رقم الموبايل",
    subject: "الموضوع",
    message: "الرسالة",
    sending: "جاري الإرسال...",
    sendMessage: "إرسال الرسالة",
    ammanHQ: "المقر الرئيسي - عمان",
    address: "العنوان",
    phone: "الهاتف",
    whatsapp: "واتساب",
    ammanAddress: "شارع يزيد الأسدي، الدوار السابع، عمّان، الأردن",
    ammanPhone: "+962 79 292 3333",
    dubaiBranch: "فرع دبي",
    dubaiAddress: "شارع أم سقيم، البرشاء، دبي، الإمارات العربية المتحدة",
    dubaiPhone: "+971 50 700 5035",
    contactEmails: "البريد الإلكتروني",
    supportEmail: "البريد الإلكتروني للدعم",
    hrEmail: "البريد الإلكتروني للموارد البشرية",
    followUs: "تابعنا:",
    alertSuccess: "شكرًا لك! تم إرسال رسالتك بنجاح",
    alertFail: "فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى",
    alertError: "حدث خطأ أثناء الإرسال. يرجى المحاولة لاحقًا",
    ammanInstagram: "إنستغرام (عمان)",
    dubaiInstagram: "إنستغرام (دبي)",
  },
};

function Contact() {
  const { language } = useLanguage();
  const t = translations[language];
  const isAr = language === "ar";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const res = await fetch("/mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        alert(t.alertSuccess);
        setFormData({
          name: "",
          email: "",
          mobile: "",
          subject: "",
          message: "",
        });
      } else {
        alert(t.alertFail);
      }
    } catch (err) {
      alert(t.alertError);
    } finally {
      setSending(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <main
      style={{
        ...styles.page,
        direction: isAr ? "rtl" : "ltr",
        fontFamily: isAr
          ? "'Cairo', 'Tajawal', Tahoma, Arial, sans-serif"
          : "Segoe UI, sans-serif",
        textAlign: isAr ? "right" : "left",
      }}
    >
      <h2 style={styles.pageTitle}>{t.pageTitle}</h2>

      <div style={styles.wrapper}>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.row}>
            <input
              type="text"
              name="name"
              placeholder={t.name}
              value={formData.name}
              onChange={handleChange}
              style={styles.input}
              required
              disabled={sending}
              dir={isAr ? "rtl" : "ltr"}
            />
            <input
              type="email"
              name="email"
              placeholder={t.email}
              value={formData.email}
              onChange={handleChange}
              style={styles.input}
              required
              disabled={sending}
              dir={isAr ? "rtl" : "ltr"}
            />
          </div>
          <div style={styles.row}>
            <input
              type="text"
              name="mobile"
              placeholder={t.mobile}
              value={formData.mobile}
              onChange={handleChange}
              style={styles.input}
              required
              disabled={sending}
              dir={isAr ? "rtl" : "ltr"}
            />
            <input
              type="text"
              name="subject"
              placeholder={t.subject}
              value={formData.subject}
              onChange={handleChange}
              style={styles.input}
              required
              disabled={sending}
              dir={isAr ? "rtl" : "ltr"}
            />
          </div>
          <textarea
            name="message"
            placeholder={t.message}
            value={formData.message}
            onChange={handleChange}
            rows="8"
            style={styles.textarea}
            required
            disabled={sending}
            dir={isAr ? "rtl" : "ltr"}
          ></textarea>
          <button type="submit" style={styles.button} disabled={sending}>
            {sending ? t.sending : t.sendMessage}
          </button>
        </form>

        <div style={styles.contactInfo}>
          <h3 style={styles.infoTitle}>{t.ammanHQ}</h3>
          <div style={styles.infoBlock}>
            <FaMapMarkerAlt style={styles.icon} />
            <div>
              <strong>{t.address}</strong>
              <p dir={isAr ? "rtl" : "ltr"} style={{ margin: 0 }}>
                {t.ammanAddress}
              </p>
            </div>
          </div>
          <div style={styles.infoBlock}>
            <FaPhone style={styles.icon} />
            <div>
              <strong>{t.phone}</strong>
              <p dir="ltr" style={{ margin: 0 }}>
                {translations.en.ammanPhone}
              </p>
            </div>
          </div>
          <div style={styles.infoBlock}>
            <FaWhatsapp style={styles.icon} />
            <div>
              <strong>{t.whatsapp}</strong>
              <p dir="ltr" style={{ margin: 0 }}>
                {translations.en.ammanPhone}
              </p>
            </div>
          </div>
          <div style={styles.infoBlock}>
            <a
              href="https://www.instagram.com/we.mass/?hl=en"
              target="_blank"
              rel="noreferrer"
              style={{ ...styles.icon, ...styles.instagramClickableIcon }}
              title={t.ammanInstagram}
            >
              <FaInstagram />
            </a>
            <div>
              <strong>{t.ammanInstagram}</strong>
            </div>
          </div>
          <h3 style={styles.infoTitle}>{t.dubaiBranch}</h3>
          <div style={styles.infoBlock}>
            <FaMapMarkerAlt style={styles.icon} />
            <div>
              <strong>{t.address}</strong>
              <p dir={isAr ? "rtl" : "ltr"} style={{ margin: 0 }}>
                {t.dubaiAddress}
              </p>
            </div>
          </div>
          <div style={styles.infoBlock}>
            <FaPhone style={styles.icon} />
            <div>
              <strong>{t.phone}</strong>
              <p dir="ltr" style={{ margin: 0 }}>
                {translations.en.dubaiPhone}
              </p>
            </div>
          </div>
          <div style={styles.infoBlock}>
            <FaWhatsapp style={styles.icon} />
            <div>
              <strong>{t.whatsapp}</strong>
              <p dir="ltr" style={{ margin: 0 }}>
                {translations.en.dubaiPhone}
              </p>
            </div>
          </div>
          <div style={styles.infoBlock}>
            <a
              href="https://www.instagram.com/wemass.uae/"
              target="_blank"
              rel="noreferrer"
              style={{ ...styles.icon, ...styles.instagramClickableIcon }}
              title={t.dubaiInstagram}
            >
              <FaInstagram />
            </a>
            <div>
              <strong>{t.dubaiInstagram}</strong>
            </div>
          </div>
          <h3 style={styles.infoTitle}>{t.contactEmails}</h3>
          <div style={styles.infoBlock}>
            <FaEnvelope style={styles.icon} />
            <div>
              <p dir="ltr" style={{ margin: 0 }}>
                info@we-mass.com
              </p>
            </div>
          </div>

          <div style={styles.socialLinks}>
            <p style={{ fontWeight: "bold", marginTop: "1.5rem" }}>
              {t.followUs}
            </p>
            <div style={styles.socialIcons}>
              <a
                href="https://www.facebook.com/we.mass1/"
                target="_blank"
                rel="noreferrer"
                style={styles.socialIcon}
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.instagram.com/we.mass/"
                target="_blank"
                rel="noreferrer"
                style={styles.socialIcon}
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/mass-smartsolutions/"
                target="_blank"
                rel="noreferrer"
                style={styles.socialIcon}
              >
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>
      </div>

      {showButton && (
        <button onClick={scrollToTop} style={styles.backToTopBtn}>
          <FaChevronUp />
        </button>
      )}
    </main>
  );
}

const styles = {
  page: {
    padding: "2rem 1rem",
    maxWidth: "1300px",
    margin: "0 auto",
    fontFamily: "Segoe UI, sans-serif",
    color: "#1b2f5f",
  },
  pageTitle: {
    fontSize: "1.7rem",
    fontWeight: "600",
    color: "#1a4bb7",
    marginBottom: "2rem",
  },
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: "2rem",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  form: {
    flex: 2,
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
    minWidth: "300px",
  },
  row: {
    display: "flex",
    gap: "1rem",
    flexWrap: "wrap",
  },
  input: {
    flex: 1,
    padding: "0.9rem",
    fontSize: "1rem",
    border: "1px solid #b0c4db",
    borderRadius: "8px",
  },
  textarea: {
    width: "100%",
    padding: "1rem",
    fontSize: "1rem",
    border: "1px solid #b0c4db",
    borderRadius: "8px",
    resize: "vertical",
    minHeight: "610px",
  },
  button: {
    padding: "1rem",
    background: "linear-gradient(to right, #007bff, #00b5f7)",
    color: "#fff",
    border: "none",
    fontSize: "1.1rem",
    fontWeight: "bold",
    borderRadius: "8px",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  contactInfo: {
    flex: 1,
    minWidth: "280px",
    padding: "2rem",
    backgroundColor: "#f3f8fc",
    borderRadius: "12px",
    boxShadow: "0 0 10px rgba(0,0,0,0.05)",
  },
  infoTitle: {
    fontSize: "1.4rem",
    marginBottom: "1.3rem",
    color: "#1b2f5f",
  },
  infoBlock: {
    display: "flex",
    alignItems: "center",
    gap: "0.8rem",
    marginBottom: "1.3rem",
  },
  icon: {
    fontSize: "1.4rem",
    color: "#007bff",
    marginTop: "0.2rem",
    minWidth: "1.4rem",
    transition: "color 0.2s",
  },
  instagramClickableIcon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    padding: 0,
    background: "none",
  },
  socialLinks: {
    marginTop: "2rem",
  },
  socialIcons: {
    display: "flex",
    gap: "1rem",
    fontSize: "1.6rem",
    marginTop: "0.5rem",
  },
  socialIcon: {
    color: "#007bff",
  },
  backToTopBtn: {
    position: "fixed",
    bottom: "40px",
    left: "25px",
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    backgroundColor: "#333",
    color: "#fff",
    border: "none",
    fontSize: "20px",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
    cursor: "pointer",
    zIndex: 999,
    transition: "opacity 0.3s ease, transform 0.3s ease",
  },
};

export default Contact;
